import { environment } from "../../../environments/environment";

// Single source of truth for the API base. In local dev this is the relative
// `/api/v1` (served through the ng-serve proxy); production builds swap in
// environment.prod.ts via angular.json fileReplacements, baking in the
// absolute API URL (no proxy exists in prod).
export const API_BASE_URL = environment.apiBaseUrl;

// masterdata-service is a DIFFERENT origin from the SP API — it owns the
// single-table lookup store that backs dropdowns (e.g. the services catalog).
export const MASTERDATA_BASE_URL = environment.masterdataBaseUrl;

export const MAX_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE = 25;
export const TENANT_ID = "davaco";

export enum AUTH0_ROLES {
  SP_OWNER = "sp-owner",
  SP_ADMIN = "sp-admin",
  SP_EMPLOYEE = "sp-employee"
}

export enum DAVACO_ROLES {
  DAVACO_ADMIN = "ct-admin",
  DAVACO_USER = "davaco-user",
  SERVICE_ACCOUNT = "service-account"
}

export enum AUTH_SOURCES {
  AAD = "aad",
  AUTH0 = "auth0"
}
